/**
 * AERO Footer — Intersection-Observer reveal animations.
 *
 * Replaces framer-motion's `whileInView` behaviour with
 * a lightweight vanilla JS observer that toggles `.is-visible`
 * on each `.aero-footer__animated` element.
 *
 * Respects `prefers-reduced-motion` — if the user wants less
 * motion the class is added immediately (no animation).
 */
(function () {
  'use strict';

  /* ── Reduced-motion guard ─────────────────────────── */
  var prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initFooterAnimations() {
    var targets = document.querySelectorAll('.aero-footer__animated');

    if (!targets.length) return;

    /* If reduced-motion is active, reveal everything instantly */
    if (prefersReducedMotion) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    /* ── IntersectionObserver – single observer, stagger via CSS var ── */
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            /* Read stagger delay from the data attribute (seconds) */
            var delay = parseFloat(el.dataset.animDelay) || 0;

            setTimeout(function () {
              el.classList.add('is-visible');
            }, delay * 1000);

            /* Once visible, stop observing (once: true behaviour) */
            observer.unobserve(el);
          }
        });
      },
      {
        /* Trigger when 15% of the element is visible */
        threshold: 0.15,
      }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Boot ──────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAnimations);
  } else {
    initFooterAnimations();
  }
})();
